module.exports = __webpack_public_path__ + "static/img/01038B_7_C_20230525_fit.8b1b0f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/01038B_7_C_20230525_fit.png
// module id = /RtE
// module chunks = 0